/**
 * useAccountRereadOnReturn — relire le compte quand l'élève revient sur l'onglet, sous la garde
 * partagée (`accountRereadGuard`) : l'accueil et Activités l'appellent tous les deux.
 *
 *  - au premier passage, rien : la coquille vient de lire le compte (`BottomTabsNavigator`) ;
 *  - à chaque retour, la relecture, sauf si une lecture est en vol ou partie il y a moins de 30 s.
 *
 * Toute lecture du compte vue en vol est notée, d'où qu'elle parte : celle de la coquille au retour
 * au premier plan vaut donc aussi pour le retour sur l'onglet qui suit.
 */
import { useFocusEffect } from "@react-navigation/native"
import { useCallback, useEffect, useRef } from "react"
import { useDispatch, useSelector, useStore } from "react-redux"

import { apiRequest } from "../../../../../data/redux/actions/api"
import { authService } from "../../../../../data/services/authService"
import { accountRereadDue, lastAccountRead, noteAccountRead } from "./accountRereadGuard"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectAccountInFlight = (state: any): boolean => !!state?.api?.getUser?.request

export function useAccountRereadOnReturn(): void {
    const dispatch = useDispatch()
    const store = useStore()
    const inFlight = useSelector(selectAccountInFlight)

    useEffect(() => {
        if (inFlight) noteAccountRead(Date.now())
    }, [inFlight])

    const firstFocusRef = useRef(true)
    useFocusEffect(
        useCallback(() => {
            if (firstFocusRef.current) {
                firstFocusRef.current = false
                return
            }
            // Lu au moment du retour, pas au rendu : une lecture partie entre-temps compte.
            const due = accountRereadDue({
                inFlight: selectAccountInFlight(store.getState()),
                lastReadAt: lastAccountRead(),
                now: Date.now(),
            })
            if (!due) return
            noteAccountRead(Date.now())
            dispatch(apiRequest(authService.getUser) as never)
        }, [dispatch, store])
    )
}
